var map = {
	"./base-init.conf.ts": 10935,
	"./baseConfiguration.ts": 1684,
	"./baseSelectorConfiguration.ts": 39387,
	"legacy/customer/base/brandbase/base-init.conf.ts": 10935,
	"legacy/customer/base/brandbase/baseConfiguration.ts": 1684,
	"legacy/customer/base/brandbase/baseSelectorConfiguration.ts": 39387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6902;